import { cn } from '@/libs/utils';

export default function TextSkeleton({ className, count = 2 }) {
  return (
    <span
      className={cn(
        'inline-flex h-8 items-center justify-center gap-3',
        className
      )}
    >
      {Array.from({ length: count }).map((_, idx) => (
        <span
          key={idx}
          className="h-1/2 w-20 animate-pulse rounded-xl bg-zinc-200"
        />
      ))}
    </span>
  );
}
